import { getDatabase, ref, update } from 'firebase/database';
import { BuildingType } from '../types/BuildingTypeEnums';
import { recordActivity } from './activityApi';

/**
 * API for building type operations.
 * Handles updates to buildingsSummary/{buildingKey}/buildingType
 */
export const buildingTypeApi = {
    /**
     * Update a building's type.
     * @param buildingKey - The building's unique key
     * @param buildingType - The new building type
     */
    async updateBuildingType(
        buildingKey: string,
        buildingType: BuildingType
    ): Promise<void> {
        if (!buildingKey) {
            throw new Error('buildingKey krävs');
        }

        const db = getDatabase();
        const summaryRef = ref(db, `buildingsSummary/${buildingKey}`);
        await update(summaryRef, { buildingType });
        recordActivity('building.updated', { buildingKey, targetKey: buildingKey });
    },
};
